import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center overflow-hidden" data-id="element-68">
      {/* Background image */}
      <div className="absolute inset-0 z-0" data-id="element-69">
        <img src="https://cdn.magicpatterns.com/uploads/gAJxtWU5NoU6s5UnkA77i2/heylloyd-image-1772215638484.png" alt="" aria-hidden="true" className="w-full h-full object-cover" data-id="element-70" />
        {/* Overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-r from-cream/95 via-cream/85 to-cream/40 lg:to-transparent" data-id="element-71"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 py-24 md:py-32" data-id="element-72">
        <div className="max-w-2xl" data-id="element-73">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-74">
            <span className="inline-block py-1 px-3 rounded-full bg-sage/15 text-sage-dark text-sm font-medium tracking-wide uppercase mb-6 backdrop-blur-sm" data-id="element-75">
              Guía Práctica para Padres
            </span>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-76">
              El Botiquín Natural de Emergencia{' '}
              <span className="text-sage block mt-2 text-3xl md:text-4xl lg:text-5xl font-medium italic" data-id="element-77">
                (0-5 años)
              </span>
            </h1>
            <p className="text-lg md:text-xl text-brown-body/90 leading-relaxed mb-8" data-id="element-78">
              Toma el control de las crisis de salud más comunes de tu hijo sin
              recurrir a químicos agresivos, colorantes artificiales o esperas
              eternas en urgencias.
            </p>
            <motion.a href="#offer" onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
            e.preventDefault();
            document.getElementById('offer')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="inline-flex items-center justify-center px-8 py-4 text-base font-medium text-white bg-terracotta hover:bg-terracotta-dark rounded-md shadow-lg shadow-terracotta/20 transition-colors duration-300 w-full sm:w-auto" data-id="element-79">
              QUIERO EL BOTIQUÍN NATURAL AHORA
            </motion.a>
          </motion.div>
        </div>
      </div>
    </section>;
}